import styled from 'styled-components'

export const ListItem = styled.li`
  padding: 10px 10px 0 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${props => props.theme.colors.white};
`

export const Button = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 40px;
  height: 100%;
  padding: 0 15px 0 65px;
  border: 1px solid ${props => props.theme.colors.secondaryLight};
  border-radius: 6px;
  background: #fff;

  & > svg,
  & > i.fa {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
  }
`

export const NavigationBody = styled.div`
  padding-top: ${props => (props.withoutPadding ? '0px' : '20px')};
  height: 100%;
  max-height: calc(100% - 40px);
`



// WEBPACK FOOTER //
// ./src/components/NavigationItem/theme.js